import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@src/environments/environment';
import { EnpsComponent } from '@src/suite/common/components/base/enps-component';
import { ErrorLS } from '@src/suite/common/data-models/misc/errors';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { LanguageSettings } from '@src/suite/common/services/language-settings';
import { NavigationService } from '@src/suite/common/services/navigation-service';

@Component({
    selector: 'st-dialog-about',
    templateUrl: 'top-bar-user-menu-dialog-about.html',
    styleUrls: ['top-bar-user-menu-dialog-about.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-dialog-about' },
})
export class TopBarUserMenuDialogAboutComponent extends EnpsComponent implements OnInit {
    private warningErrors: Array<ErrorLS>;
    private criticalErrors: Array<ErrorLS>;
    public hasErrors: boolean = false;
    public app_version: string = '';

    constructor(
        public dialogRef: MatDialogRef<TopBarUserMenuDialogAboutComponent>,
        public languageSettings: LanguageSettings,
        public navigationService: NavigationService,
        public globalTablesService: GlobalTablesService
    ) {
        super();
    }
    ngOnInit(): void {
        if (environment.pst_version) {
            this.app_version = environment.pst_version.toLowerCase();
            this.globalTablesService.AppVersion = this.app_version;
            this.globalTablesService.setPlaybookHelpUrl();
            this.globalTablesService.setEnforceRequiredFieldsOnCreate();
        }
        this.hasErrors = this.checkIsThereErrorLog();
    }

    get productLabel(): string {
        return this.languageSettings.PSTWebApStorytellingLabel;
    }

    public closeDialog() {
        this.dialogRef.close();
    }

    private checkIsThereErrorLog(): boolean {
        let errorsStr = localStorage.getItem('warningErrors');
        if (errorsStr) {
            let errors = [];
            try {
                errors = <Array<ErrorLS>>JSON.parse(errorsStr);
            } catch (err) {
                console.log(err);
            }
            this.warningErrors = errors;
        }
        errorsStr = localStorage.getItem('criticalErrors');
        if (errorsStr) {
            let errors = [];
            try {
                errors = <Array<ErrorLS>>JSON.parse(errorsStr);
            } catch (err) {
                console.log(err);
            }
            this.criticalErrors = errors;
        }

        if ((this.warningErrors && this.warningErrors.length > 0) || (this.criticalErrors && this.criticalErrors.length > 0)) {
            return true;
        }
        return false;
    }

    public downloadErrors() {
        let text = '';
        if (this.criticalErrors && this.criticalErrors.length > 0) {
            text += 'CRITICAL:\n\r\n\r';
            for (const error of this.criticalErrors) {
                const msg = error.msg.replace(/[\n\r+]/gi, '');
                text += `[${error.timestamp}] - ${error.type.toUpperCase()} - ${msg}\n\r\n\r`;
            }
        }

        if (this.warningErrors && this.warningErrors.length > 0) {
            if (this.criticalErrors && this.criticalErrors.length > 0) {
                text += '\n\r\n\r------------------------------------------------------------------------------------\n\r\n\r\n\r\n\r';
            }
            text += 'WARNING:\n\r\n\r';
            for (const error of this.warningErrors) {
                const msg = error.msg.replace(/[\n\r+]/gi, '');
                text += `[${error.timestamp}] - ${error.type.toUpperCase()} - ${msg}\n\r\n\r`;
            }
        }

        const data = new Blob([text], { type: 'text/plain' });
        const element: HTMLAnchorElement = document.createElement<'a'>('a');
        element.download = 'errors.log';
        const textFile = window.URL.createObjectURL(data);
        element.href = textFile;
        element.click();
    }
}
